/*
 * @FilePath     : /fe-estrain-customer/src/store/modules/user/mutation.js
 * @Author       : LiYang
 * @Date         : 2021-08-26 10:48:43
 * @LastEditTime: 2023-06-06 10:44:48
 * @LastEditors: liuziwei
 * @Description  :
 */

import { AES_ECB_DECRYPT } from '@/common/crypto'
export default {
  setContactSelected(state, payload) {
    let passengerList = []
    payload.map(item => {
      passengerList.push({
        id: item?.id,
        passenger_name: item?.passenger_name,
        encrypt_phone: AES_ECB_DECRYPT(item?.phone),
        mobile_no: AES_ECB_DECRYPT(item?.phone),
        card_list: [{
          card_name: item?.id_name,
          id_no: item?.id_no,
          card_type: item?.id_type,
          secret_card_no: item?.encrypt_id_no
        }],
        traveler_id: item?.traveler_id,
        member_id: item?.member_id
      })
    })
    state.selectedContact = passengerList;
    console.log("result", passengerList)
  },
  setTravelerList(state, payload) {
    state.travelerListForLoginPage = payload
  },
}
